const FIRM_ACCOUNT_TYPE_CUSTOMER = 'CUSTOMER';
const FIRM_ACCOUNT_TYPE_TEST = 'TEST';
const FIRM_ACCOUNT_TYPE_DEMO = 'DEMO';

const FIRM_ACCOUNT_TYPE_LABELS = {
  [FIRM_ACCOUNT_TYPE_CUSTOMER]: 'Customer',
  [FIRM_ACCOUNT_TYPE_TEST]: 'Test',
  [FIRM_ACCOUNT_TYPE_DEMO]: 'Demo',
};

export const FIRM_ACCOUNT_TYPE_OPTIONS = [
  { value: FIRM_ACCOUNT_TYPE_CUSTOMER, label: 'Customer' },
  { value: FIRM_ACCOUNT_TYPE_TEST, label: 'Test' },
  { value: FIRM_ACCOUNT_TYPE_DEMO, label: 'Demo' },
];

export const getFirmAccountTypeLabel = (value) => {
  if (!value) return 'Not Set';
  return FIRM_ACCOUNT_TYPE_LABELS[value] || value;
};

export const getFirmAccountTypeFilterOptions = async () => ([
  { value: '-1', label: 'Not Set' },
  ...FIRM_ACCOUNT_TYPE_OPTIONS,
]);